import {msi} from '../../styles/normalizeSize';

export const TEXT_FIELDS_SCROLL_OFFSET = msi(-35);
